<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark>
            <v-toolbar-title>Roles
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="grey darken-2" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>

                </v-card-title>
                <v-card-text>

                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.name" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" dark @click.native="editRole(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                          <v-btn v-else color="yellow darken-2" dark @click.native="addRole(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog><!-- end dialog edit o save-->
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="rolesList"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
          >
            <template v-slot:item.action="{ item }">
              <v-icon color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon color="red"  @click="deleteRole(item)">mdi-close</v-icon>
              <!--<v-icon dark>mdi-folder-settings-variant</v-icon>-->
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      changePassword:false,
      mask: '##########',
      celular: '',
      valid: true,
      dialog: false,
      loading:false, //component
      show: false,
      headers: [
        // {
        //   text: 'Usuario',
        //   align: 'left',
        //   sortable: true,
        //   value: 'name'
        // },
        { text: 'Role', value: 'name', sortable: true },
        { text: 'Acciones', value: 'action' }
      ],
      //listUsers: [],
      rolesList: [],
      distritosList:[],
      editedIndex: -1,
      editedItem: {
        name:'',
      },
      defaultItem: {
        name:'',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      // emailRules: [
      //   v => !!v || 'El campo es requerido',
      //   v => /.+@.+\..+/.test(v) || 'Ingrese un correo valido',
      // ]
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Role' : 'Editar Role'
    }
  },
  mounted() {
    this.getRoles();
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    getRoles() {
      this.$store
        .dispatch("GET_ROLES")
        .then((response) => {
          this.rolesList = response.data;//usar response para datos, se puede usar getters
          //console.log(response);
        })
        .catch(err => {
          console.log(err);
          //this.showAlert(this.notification);
        });
    },
    editItem (item) {
      this.editedIndex = this.rolesList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    addRole(){
      var data = this.editedItem;
      this.$store
        .dispatch("SAVE_ROLES",data)
        .then((response) => {
          console.log(response.message);
          this.close ();
          Swal.fire({
            icon: 'success',
            title: 'Se Guardo Correctamente',
            showConfirmButton: false,
            timer: 1500
          })
          this.getRoles();
          //this.roles = response.data;//usar response para datos, se puede usar getters
          //console.log(response);
        })
        .catch(error => {
          console.log(error);
          if(error.response.data.status){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              title: error.response.data.status,
              confirmButtonText: "Aceptar"
            })
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Error',
              title: 'Verifique los campos requeridos',
              showConfirmButton: false,
              timer: 1500
            })
          }

          //this.showAlert(this.notification);
        });
    },
    editRole(item){
      console.log("store",item);
      //var data = this.$data;
      this.$store
        .dispatch("EDIT_ROLE",item)
        .then((response) => {
          this.dialog=false;
          Swal.fire({
            icon: 'success',
            title: 'Actualizado Correctamente',
            showConfirmButton: false,
            timer: 1500
          })
          this.getRoles();
          //this.roles = response.data;//usar response para datos, se puede usar getters
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: err.response.data.status,
            showConfirmButton: false,
            timer: 1500
          })
          //this.showAlert(this.notification);
        });
    },
    deleteRole(item){
      confirm('Seguro de eliminar el Role?') &&
      //console.log("store",item.id);
      //var data = this.$data;
      this.$store
        .dispatch("DELETE_ROLE",item.id)
        .then((response) => {
          Swal.fire({
            icon: 'success',
            title: 'Se Eliminó Correctamente',
            showConfirmButton: false,
            timer: 1500
          })
          this.getRoles();
        })
        .catch(err => {
          console.log(err);
          //this.showAlert(this.notification);
        });
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
